import { Navigate } from 'react-router-dom';
import { usePermissions } from 'hooks/usePermissions';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, moduleKey, requireWrite = false }) => {
  const { loaded, loading, hasReadPermission, hasWritePermission } = usePermissions();

  if (loading || !loaded) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Check if user has required permission
  const hasAccess = requireWrite 
    ? hasWritePermission(moduleKey)
    : hasReadPermission(moduleKey);

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;